import * as _ from "lodash"
import {PAdbContext} from "../PA.Core/PAdbContext";
import {IHierarchyNodeProvider, IHierarchyStructure} from "../PA.MD.Core/PA.MD.IF.Hierarchy";
import {HierarchyHarness} from "./HierarchyHarness";
import {CustomerHierarchyStructure} from "./CustomerHierarchyStructure";
import {ProductHierarchyStructure} from "./ProductHierarchyStructure";
import {CustomerNodeProvider} from "./CustomerNodeProvider";
import {ProductNodeProvider} from "./ProductNodeProvider";
import {PeriodHierarchyStructure} from "./PeriodHierarchyStructure";
import {PeriodNodeProvider} from "./PeriodNodeProvider";
import {esWB_Hierarchy} from "../PA.Core/PAdbSchema";
import {WB_HierarchyRow} from "../PA.Core/PAdbSchemaRows";

export class HierarchyStructureManager {

    static dctWbHierarchyIdByDimWbTgtId: {[entityDimension: string]: {[wbTargetId: number]: number}} = {}


    static async getHierarchyStructure(wbHierarchyId: number, options?: { dbContext?: PAdbContext, harness?: HierarchyHarness }): Promise<IHierarchyStructure> {
        let rv: IHierarchyStructure = undefined
        let harness = options?.harness

        if (_.isEmpty(harness))
            harness = await HierarchyHarness.findHarness(wbHierarchyId, {dbContext: options?.dbContext})

        if (_.isEmpty(harness))
            return undefined

        if (wbHierarchyId > 0) {
            switch (harness.WB_HierarchyRow.cif.ENTITY_DIMENSION) {
                case "Customer":
                    rv = new CustomerHierarchyStructure(wbHierarchyId, {
                        dbContext: <PAdbContext>harness?.WB_HierarchyRow.dataStore(), harness: harness
                    })
                    await rv.OnLoadComplete()
                    break
                case "Product":
                    rv = new ProductHierarchyStructure(wbHierarchyId, {
                        dbContext: <PAdbContext>harness?.WB_HierarchyRow.dataStore(), harness: harness
                    })
                    await rv.OnLoadComplete()
                    break
                case "Period":
                    rv = new PeriodHierarchyStructure(wbHierarchyId, {
                        dbContext: <PAdbContext>harness?.WB_HierarchyRow.dataStore(), harness: harness
                    })
                    await rv.OnLoadComplete()
                    break
            }
        }

        return rv
    }

    static geDimensionNodeProvider(sEntityDimension: string, wbMDSetId: number, dbContext?: PAdbContext): IHierarchyNodeProvider {
        let context = dbContext
        if(_.isEmpty(context))
            context = new PAdbContext()

        switch (sEntityDimension){
            case "Customer":
                return new CustomerNodeProvider(context,wbMDSetId)

            case "Product":
                return new ProductNodeProvider(context, wbMDSetId)
            case "Period":
                return new PeriodNodeProvider(context, wbMDSetId)

        }

        return undefined
    }

    static async getWbHierarchyId(sEntityDimension: string, wbTargetId: number): Promise<number> {
        if(!(sEntityDimension in HierarchyStructureManager.dctWbHierarchyIdByDimWbTgtId))
            HierarchyStructureManager.dctWbHierarchyIdByDimWbTgtId[sEntityDimension] = {}
        let subDct = HierarchyStructureManager.dctWbHierarchyIdByDimWbTgtId[sEntityDimension]

        if(wbTargetId in subDct)
            return subDct[wbTargetId]

        let dbContext = new PAdbContext()
        let recs = <WB_HierarchyRow[]> await dbContext.findAll(esWB_Hierarchy, {where: {ENTITY_DIMENSION: sEntityDimension, TARGET_WB_ID: wbTargetId, DELETED_IND: {neq: '1'}}})
        let a = _.first(recs)
        if(_.isEmpty(a))
            return
        subDct[wbTargetId] = a.cif.WB_HIERARCHY_ID

        return a.cif.WB_HIERARCHY_ID
    }

}